import { Outlet } from 'react-router-dom';

import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import ScrollToTop from '../common/ScrollToTop/scrollToTop';
import Toast from '../common/Toast/Toast';
import Modal from '../common/Modal/Modal/Modal';
import SideButton from '../common/Button/SideButton';
import useIsMobile from '@/hooks/useIsMobile';

const Layout = () => {
	const { pathname } = window.location;
	const isMoble = useIsMobile(900);
	return (
		<>
			<Modal />
			<Toast />
			<ScrollToTop />

			<Header />
			<Outlet />
			{(pathname !== '/mypage' || !isMoble) && <Footer />}

			<SideButton />
		</>
	);
};

export default Layout;
